import { requestAction, requestActionCompleted } from 'actions';
import { PURCHASE_ACTIONS } from 'constants';
import { PlanModel } from 'models/PlanModel';
import { attunedApi } from 'services';

const {
    PURCHASE, PURCHASE_SUCCESS, PURCHASE_FAILED,
    GET_PLANS,
    GET_PLANS_SUCCESS,
    GET_PLANS_ERROR,
} = PURCHASE_ACTIONS;

export function getPlans() {
    const url = '/get_plans';
    return dispatch => {
        dispatch(requestAction(GET_PLANS));
        return attunedApi.get(url)
            .then(res => res.map(item => new PlanModel(item)))
            .then(data => dispatch(requestActionCompleted(GET_PLANS_SUCCESS, data)))
            .catch(error => dispatch(requestActionCompleted(GET_PLANS_ERROR, error)));
    };
}

export function purchase(data) {
    const url = '/charge';
    return dispatch => {
        dispatch(requestAction(PURCHASE));
        return attunedApi.post(url, data).then(response => {
            dispatch(requestActionCompleted(PURCHASE_SUCCESS, response));
        }).catch(error => {
            dispatch(requestActionCompleted(PURCHASE_FAILED, error));
        });
    };
}
